// app level reducer

import {
  BEGIN_AJAX_CALL,
  END_AJAX_CALL,
  SHOW_DRAGGER,
  GET_ADD_UNIT_LIST,
  GET_ADD_UNIT_GROUP_LIST,
  GET_PMP_LIST,
  GET_TAGLD_MAPPING_LIST,
  GET_TAGLD_MAPPING_ADUNIT_ALL_LIST,
  GET_TAGLD_MAPPING_BULK_LIST,
  DISPATCH_PLATFORM_CONFIGURATION_LIST,
  GET_CONFIGURATION_DATA,
  GET_FILTER_LIST,
  GET_ION_FILTER_LIST,
  GET_MEDIA_REPORT,
  GET_ION_EXCHANGE_REPORT,
  GET_QPS_REPORT,
  GET_REVENUE_REPORT,
  GET_BIDDER_REPORT,
  GET_MEDIA_PLANNING_REPORT,
  GET_CAMPAIGN_PERFORMANCE_REPORT,
  GET_CAMPAIGN_LIST_ALL_REPORT,
  GET_CAMPAIGN_CATEGORY_TYPE_LIST,
  GET_IO_LIST_ALL_REPORT,
  GET_COUNTRY_LIST,
  GET_CITY_LIST_ALL,
  GET_STATE_LIST_ALL,
  GET_STATE_LIST,
  GET_CITY_LIST,
  GET_CAMPAIGN_SUB_CATEGORY,
  GET_ADVERTISER_CREATIVE_GROUP,
  GET_IO_ADVERTISER_LIST_REPORT,
  GET_TENANT_LIST_ALL,
  GET_SUPPLY_PARTNER_LIST_ALL,
  GET_DEMAND_PARTNER_LIST_ALL,
  GET_TENANT_DEMAND_PARTNER_LIST,
  GET_ADMIN_SUPPLY_PARTNER_LIST_ALL,
  GET_TENANT_SUPPLY_PARTNER_LIST_ALL,
  GET_ADMIN_ION_SUPPLY_PARTNER_LIST_ALL,
  GET_ADMIN_PVT_SUPPLY_PARTNER_LIST_ALL,
  GET_LIST_FEATURE_ALL,
  GET_FEATURE_LIST_ALL,
  GET_MEDIATION_LIST,
  GET_MEDIATION_AD_GROUP_LIST,
  GET_PRIVATE_MARKET_PLACE_LIST,
  GET_EXCHANGE_LIST_REPORT,
  GET_AGREEMENT_LIST_ALL,
  GET_AGREEMENT_CONNECTION_LIST,
  GET_ADMIN_USER_LIST_ALL,
  GET_PLATFORM_LIST_ALL,
  GET_ADMIN_ROLES_LIST_ALL,
  GET_DEMAND_PARTNER_NAME_LIST_ALL,
  GET_USER_PERMISSION,
  GET_APR_LIST_ALL,
  GET_SEGMENT_LIST_ALL,
  GET_HIERARCHY_LIST_ALL,
  GET_DATA_CAPTURE_LIST_ALL,
  GET_AUDIENCE_HIERARCHY_LIST_ALL,
  GET_PINCODE_LIST,
  GET_CAMPAIGN_SITE_LIST_ALL,
  GET_CAMPAIGN_PERFORMANCE_REPORT_TREND,
  GET_MEDIA_PLANNING_REPORT_TREND,
  GET_PINCODE_LIST_ALL,
  GET_CAMPAIGN_PIXEL_LIST,
  GET_DEMAND_PARTNER_SEAT_LIST_ALL,
  GET_CAMPAIGN_PERFORMANCE_REPORT_FILTER_LIST,
  GET_CAMPAIGN_DATA,
  GET_CAMPAIGN_PREVIEW_DATA,
  GET_CAMPAIGN_ACCORDIAN_OPEN_DATA,
  GET_ADD_STRATEGY_DATA,
  GET_SAVE_REPORT,
  GET_MEDIA_SAVE_REPORT,
  GET_GENERATE_REPORT,
  GET_DATACONFIG_LIST_DATA,
  GET_REFRESH_REPORT,
  GET_ACCOUNTS_LIST,
  GET_USER_REACH_REPORT,
  GET_ROADBLOCK_LIST,
  // GET_CAMPAIGN_PERFORMANCE_REPORT,
  POST_CAMPAIGN_PERFORMACE_REPORT,
  POST_GEO_REPORT,
  POST_CREATIVE_PERFORMANCE_REPORT,
  POST_AGE_GENDER_REPORT,
  POST_CREATIVE_DETAILS,
  CREATE_ADVERTISER,
  ADVERTISER_LIST,
  GET_MEDIA_PLAN_LIST,
  GET_OPTIMIZER_LIST,
  GET_AGE_LIST,
  GET_CATEGORY_LIST,
  GET_SUBCATEGORY_LIST,
  POST_MEDIA_PLAN_CREATION,
  GET_PRIMARY_GOAL,
  GET_SECONDARY_GOAL,
  GET_UNMAPPED_CAMPAIGN_COUNT,
  GET_UNMAPPED_CAMPAIGN_LIST,
  RECO_IMPLEMENTATION,
  GET_ADVERTISER_LIST,
  POST_TIKTOK_VERIFICATION_URL,
  POST_CAMPAIGN_PERFORMACE_TOTAL_REPORT,
  POST_CAMPAIGN_PERFORMACE_DATEWISE_REPORT,
  POST_CHANNEL_SPEND,
  POST_WORLD_MAP_DATA,
  PAYMENT_ACCESS_ACTION_TYPE,
  GET_CURRENCY_LIST,
  GET_ALL_CURRENCY,
  GET_DATA_CONFIG,
  POST_GENDER_REPORT,
  GET_STRATEGY_CREATIVE_DETAILS,
  GET_CREATIVE_VALIDATION_DETAILS,
  GET_CREATIVE_TRACKER_DETAILS,
  GET_TOTAL_PLATFORM_DETAILS,
  GET_INFOMATERY_DETAILS,
  GET_MEDIA_LIST_DETAILS,
  GET_CAMPAIGN_NAME,
  GET_PREVIEW_DATA,
  BASIC_DETAILS,
  CUSTOM_PLAN,
  SET_STEPPER,
  STRATEGY_LIST,
  SET_LOCATION_STRATEGY,
  THIRD_PARTY_MAPPED_ACCOUNT,
  THIRD_PARTY_LOGIN_VERIFICATION_DATA,
  THIRD_PARTY_LOGIN_PARTNERS_DATA,
  POST_AGE_REPORT,
  PERTICULAR_WORLD_MAP_DATA,
  POST_PERFORMANCE_REPORT,
  POST_CREATIVE_REPORT_TABLE,
  DOMAIN_REPORT,
  POST_GEO_CAMPAIGN_ID_REPORT,
  DEVICE_REPORT,
  POST_AGE_SECREEN_2_REPORT,
  POST_GENDER_SCREEN_2_REPORT,
  GET_ALL_COUNTRYU,
  RECOMMENDED_PLAN,
  GET_RECO_LIST,
  SUBSCRIPTION_CURRENT_LIST_ALL,
  PREFERENCE_LIST,
  GET_PREVIEW_CAMPAING_DATA,
  GET_THIRD_PARTY_LIST,
  SULAR_COUNTRY_LIST,
  HOME_SCREEN_SUCCESS,
  FLUSH_REDUX_STATE,
  GET_NEW_OPTIMIZER_LIST,
  GET_USER_PROFILE_DETAILS,
  GET_FEATURE_MODULE,
  USER_MAPPED_SEATS,
  //CDR
  POST_PERFORMANCE_SUMMARY_REPORT_DATA,
  POST_PERFORMANCE_DATEWISE_REPORT_DATA,
  POST_CREATIVE_DETAIL_REPORT_DATA,
  POST_CREATIVE_DETAIL_REPORT_SUMMARISED_DATA,
  POST_CREATIVE_DETAIL_REPORT_DATEWISE_DATA,
  POST_GEO_REPORT_DATA,
  POST_DOMAIN_REPORT_DATA,
  POST_DEMOGRAPHIC_AGE_REPORT_DATA,
  POST_DEMOGRAPHIC_GENDER_REPORT_DATA,
  POST_DEVICE_DETAIL_REPORT_DATA,
  POST_AGE_REPORT_CDR,
  GET_SAVE_REPORT_CDR,
  POST_GEO_REPORT_CDR,
  POST_CREATIVE_DETAILS_CDR,
  GET_ADVERTISER_LIST_CDR,
  POST_CAMPAIGN_PERFORMACE_TOTAL_REPORT_CDR,
  POST_CAMPAIGN_PERFORMACE_DATEWISE_REPORT_CDR,
  POST_CHANNEL_SPEND_CDR,
  POST_WORLD_MAP_DATA_CDR,
  POST_CAMPAIGN_PERFORMACE_REPORT_CDR,
  POST_GENDER_REPORT_CDR,
  POST_PERFORMANCE_REPORT_CDR,

  SET_SELECTED_TENANT_FOR_PAYMENT,
  // RO functionality disabled
  // MANDATE_GROUP_LIST,
  POST_KEYWORDS_DATEWISE_REPORT_DATA,
  POST_KEYWORDS_SUMMARY_REPORT_DATA,
  POST_AUDIENCE_DATEWISE_REPORT_DATA,
  POST_AUDIENCE_SUMMARY_REPORT_DATA,
  POST_DEVICE_DETAIL_REPORT_SUMMARY_DATA,
  POST_DEVICE_DETAIL_REPORT_DATEWISE_DATA,
  POST_DOMAIN_REPORT_DATEWISE_DATA,
  POST_DOMAIN_REPORT_SUMMARY_DATA,
  POST_DEMOGRAPHIC_GENDER_REPORT_SUMMARY_DATA,
  POST_DEMOGRAPHIC_GENDER_REPORT_DATEWISE_DATA,
  POST_DEMOGRAPHIC_AGE_REPORT_SUMMARY_DATA,
  POST_DEMOGRAPHIC_AGE_REPORT_DATEWISE_DATA,
  POST_OS_REPORT_SUMMARY_DATA,
  POST_OS_REPORT_DATEWISE_DATA,
  BEGIN_DASHBOARD_AJAX_CALL,
  END_DASHBOARD_AJAX_CALL,
  POST_PERFORMANCE_WEEKWISE_REPORT_DATA,
  POST_CREATIVE_DETAIL_REPORT_WEEKWISE_DATA,
  POST_DOMAIN_REPORT_WEEKWISE_DATA,
  POST_DEMOGRAPHIC_AGE_REPORT_WEEKWISE_DATA,
  POST_DEMOGRAPHIC_GENDER_REPORT_WEEKWISE_DATA,
  POST_DEVICE_DETAIL_REPORT_WEEKWISE_DATA,
  POST_KEYWORDS_WEEKWISE_REPORT_DATA,
  POST_AUDIENCE_WEEKWISE_REPORT_DATA,
  POST_OS_REPORT_WEEKWISE_DATA,
  SET_AUDIENCE_MARKETPLACE_LOADING,
  SET_AUDIENCE_MARKETPLACE_ERROR,
  GET_AUDIENCE_MARKETPLACE_LIST,
  GET_AUDIENCE_MARKETPLACE_FILTER_OPTIONS,
  SET_AUDIENCE_MARKETPLACE_FILTERS,
  RESET_AUDIENCE_MARKETPLACE_FILTERS,
  SET_AUDIENCE_MARKETPLACE_SEARCH,
  SET_AUDIENCE_MARKETPLACE_SELECTED_RECORD,
  GET_AUDIENCE_MARKETPLACE_DETAIL,
  POST_AUDIENCE_MARKETPLACE_ACTION
} from '../constants/actionType';

const AUDIENCE_MARKETPLACE_ALL_VALUE = "all";

const getAudienceMarketplaceDefaultFilters = () => ({
  brand: AUDIENCE_MARKETPLACE_ALL_VALUE,
  category: AUDIENCE_MARKETPLACE_ALL_VALUE,
  status: AUDIENCE_MARKETPLACE_ALL_VALUE,
  sdate: "",
  edate: ""
});

const getAudienceMarketplaceEntityState = () => ({
  listResponse: null,
  filters: getAudienceMarketplaceDefaultFilters(),
  searchText: "",
  filterOptionsResponse: null,
  selectedRecord: null,
  detailResponse: null,
  postResponse: null,
  loading: false,
  error: ""
});

const getAudienceMarketplaceState = (state) => {
  if (state && state.audienceMarketPlace) {
    return state.audienceMarketPlace;
  }

  return {
    brief: getAudienceMarketplaceEntityState(),
    mediaPlan: getAudienceMarketplaceEntityState(),
    ro: getAudienceMarketplaceEntityState(),
    campaign: getAudienceMarketplaceEntityState()
  };
};

const getCurrentAudienceMarketplaceEntityState = (state, entityType) => {
  const audienceMarketPlace = getAudienceMarketplaceState(state);

  if (entityType && audienceMarketPlace[entityType]) {
    return audienceMarketPlace[entityType];
  }

  return getAudienceMarketplaceEntityState();
};

const updateAudienceMarketplaceEntityState = (state, entityType, nextValues) => {
  if (!entityType) {
    return state;
  }

  const audienceMarketPlace = getAudienceMarketplaceState(state);

  return {
    ...state,
    audienceMarketPlace: {
      ...audienceMarketPlace,
      [entityType]: {
        ...getCurrentAudienceMarketplaceEntityState(state, entityType),
        ...nextValues
      }
    }
  };
};

const app = (state = {}, action) => {
  switch (action.type) {
    case BEGIN_AJAX_CALL:
    case END_AJAX_CALL:
      const { showSpinner } = action;
      return {
        ...state,
        showSpinner
      };
    case BEGIN_DASHBOARD_AJAX_CALL:
    case END_DASHBOARD_AJAX_CALL:
      const { showDashboardSpinner } = action;
      return {
        ...state,
        showDashboardSpinner
      };
    case SHOW_DRAGGER:
      const { draggerData } = action;
      return {
        ...state,
        draggerData
      };
    case FLUSH_REDUX_STATE:
      return {
        // state: {
        //   platformConfiguration:state.platformConfiguration,
        //   platformConfigurationList: state.platformConfigurationList
        // }
        platformConfiguration: state.platformConfiguration,
        platformConfigurationList: state.platformConfigurationList
      }
    case GET_STRATEGY_CREATIVE_DETAILS:
      const { strategyCreativeData } = action;
      return {
        ...state,
        strategyCreativeData,
      };
    case GET_CAMPAIGN_DATA:
      const { campaignData } = action;
      return {
        ...state,
        campaignData,
      };
    case GET_CAMPAIGN_PREVIEW_DATA:
      const { campaignPublishData } = action;
      return {
        ...state,
        campaignPublishData,
      };
    case GET_PREVIEW_CAMPAING_DATA:
      const { previewCampaingData } = action;
      return {
        ...state,
        previewCampaingData
      }
    case GET_THIRD_PARTY_LIST:
      const { thirdPartyList } = action;
      return {
        ...state,
        thirdPartyList,
      };
    case GET_CAMPAIGN_ACCORDIAN_OPEN_DATA:
      const { campaignAccordianData } = action;
      return {
        ...state,
        campaignAccordianData,
      };

    case GET_ADD_STRATEGY_DATA:
      const { addStrategyData } = action;
      return {
        ...state,
        addStrategyData,
      };
    case GET_CREATIVE_VALIDATION_DETAILS:
      const { creativeValidationData } = action;
      return {
        ...state,
        creativeValidationData,
      };
    case GET_CREATIVE_TRACKER_DETAILS:
      const { creativeTrackerData } = action;
      return {
        ...state,
        creativeTrackerData,
      };
    case GET_TOTAL_PLATFORM_DETAILS:
      const { platformListDetails } = action;
      return {
        ...state,
        platformListDetails,
      };
    case GET_INFOMATERY_DETAILS:
      const { infomateryDetails } = action;
      return {
        ...state,
        infomateryDetails,
      };
    case GET_MEDIA_LIST_DETAILS:
      const { mediaListData } = action;
      return {
        ...state,
        mediaListData,
      };
    case GET_CONFIGURATION_DATA:
      const {
        configurationData
      } = action;
      return {
        ...state,
        configurationData,
      };
    case GET_UNMAPPED_CAMPAIGN_COUNT:
      const { countUnmapped } = action
      return {
        ...state,
        countUnmapped
      };
    case PERTICULAR_WORLD_MAP_DATA:
      const { perticualarWorldMapData } = action
      return {
        ...state,
        perticualarWorldMapData,
      }
    case POST_AGE_REPORT:
      const { ageAllReportListData } = action
      return {
        ...state,
        ageAllReportListData,
      }
    case POST_GENDER_REPORT:
      const { genderAllReportListData } = action
      return {
        ...state,
        genderAllReportListData
      }
    case POST_PERFORMANCE_REPORT:
      const { performanceReportData, id } = action
      const mergedData = {
        ...state.performanceReportData,
        [id]: performanceReportData
      };

      // Filter out the undefined: null key
      let filteredData = Object.keys(mergedData).reduce((acc, key) => {
        if (key !== 'undefined') {
          acc[key] = mergedData[key];
        }
        return acc;
      }, {});
      if (performanceReportData === null) {
        filteredData = performanceReportData;
      }
      return {
        ...state,
        performanceReportData: filteredData,
      }
    case POST_CREATIVE_REPORT_TABLE:
      const { creativeReportTableData } = action
      return {
        ...state,
        creativeReportTableData,
      }
    case POST_GEO_CAMPAIGN_ID_REPORT:
      const { geoCampaignReportList } = action
      return {
        ...state,
        geoCampaignReportList,
      }
    case POST_AGE_SECREEN_2_REPORT:
      const { ageAllReportListScreen2Data } = action
      return {
        ...state,
        ageAllReportListScreen2Data,
      }
    case POST_GENDER_SCREEN_2_REPORT:
      const { genderAllReportListScreen2Data } = action
      return {
        ...state,
        genderAllReportListScreen2Data,
      }
    case DEVICE_REPORT:
      const { deviceReportData } = action
      return {
        ...state,
        deviceReportData,
      }
    case DOMAIN_REPORT:
      const { domainReportList } = action
      return {
        ...state,
        domainReportList,
      }
    case GET_FILTER_LIST:
      const {
        filterList
      } = action;
      return {
        ...state,
        filterList,
      };
    case POST_CREATIVE_DETAILS:
      const { creativeDetailsList } = action;
      return {
        ...state,
        creativeDetailsList,
      };
    case POST_TIKTOK_VERIFICATION_URL:
      const { tiktokVerification } = action;
      return {
        ...state,
        tiktokVerification,
      }
    case GET_ION_FILTER_LIST:
      const {
        ionFilterList
      } = action;
      return {
        ...state,
        ionFilterList,
      };

    case HOME_SCREEN_SUCCESS:
      const {
        homeSignInData
      } = action;
      return {
        ...state,
        homeSignInData,
      };
    case DISPATCH_PLATFORM_CONFIGURATION_LIST:
      const { platformConfigurationList, platformConfiguration } = action;
      return {
        ...state,
        platformConfigurationList,
        platformConfiguration
      };
    case GET_ADD_UNIT_LIST:
      const { adUnitList } = action;
      return {
        ...state,
        adUnitList,
      };
    case GET_ADD_UNIT_GROUP_LIST:
      const { adUnitGroupList } = action;
      return {
        ...state,
        adUnitGroupList,
      };
    case GET_PMP_LIST:
      const { pmpList } = action;
      return {
        ...state,
        pmpList,
      };
    case GET_TAGLD_MAPPING_LIST:
      const { tagldMappingList } = action;
      return {
        ...state,
        tagldMappingList,
      };
    case GET_TAGLD_MAPPING_ADUNIT_ALL_LIST:
      const { tagldMappingListadunitAll } = action;
      return {
        ...state,
        tagldMappingListadunitAll,
      };
    case GET_TAGLD_MAPPING_BULK_LIST:
      const { tagldMappingBulkList } = action;
      return {
        ...state,
        tagldMappingBulkList,
      };
    case GET_MEDIA_REPORT:
      const { mediaReport } = action;
      return {
        ...state,
        mediaReport,
      };
    case GET_ION_EXCHANGE_REPORT:
      const { ionExchange } = action;
      return {
        ...state,
        ionExchange,
      };

    case GET_QPS_REPORT:
      const { qpsReport } = action;
      return {
        ...state,
        qpsReport,
      };
    case GET_REVENUE_REPORT:
      const { revenueReport } = action;
      return {
        ...state,
        revenueReport,
      };
    case GET_BIDDER_REPORT:
      const { bidderReport } = action;
      return {
        ...state,
        bidderReport,
      };
    case GET_MEDIA_PLANNING_REPORT:
      const { mediaPlanningReport } = action;
      return {
        ...state,
        mediaPlanningReport,
      };
    case GET_CAMPAIGN_PERFORMANCE_REPORT:
      const { campaignPerformanceReport } = action;
      return {
        ...state,
        campaignPerformanceReport,
      };
    case GET_CAMPAIGN_PERFORMANCE_REPORT_FILTER_LIST:
      const { campaignPerformanceReportFilterList } = action;
      return {
        ...state,
        campaignPerformanceReportFilterList,
      };
    case GET_CAMPAIGN_LIST_ALL_REPORT:
      const { campaignListAllReport } = action;
      return {
        ...state,
        campaignListAllReport,
      };
    case GET_IO_LIST_ALL_REPORT:
      const { ioListAllReport } = action;
      return {
        ...state,
        ioListAllReport,
      };
    case SULAR_COUNTRY_LIST:
      const { sularCountryList } = action;
      return {
        ...state,
        sularCountryList,
      };
    case GET_COUNTRY_LIST:
      const { getCountryList } = action;
      return {
        ...state,
        getCountryList,
      };
    case GET_ALL_COUNTRYU:
      const { getAllCountryData } = action;
      return {
        ...state,
        getAllCountryData,
      };
    case GET_STATE_LIST:
      const { getStateList } = action;
      return {
        ...state,
        getStateList,
      };
    case GET_CITY_LIST:
      const { getCityList } = action;
      return {
        ...state,
        getCityList,
      };
    case GET_USER_REACH_REPORT:
      const { userReachReport } = action;
      return {
        ...state,
        userReachReport,
      }
    case GET_STATE_LIST_ALL:
      const { getStateAllList, getStateAllFilterList } = action;
      return {
        ...state,
        getStateAllList,
        getStateAllFilterList
      };
    case GET_CITY_LIST_ALL:
      const { getCityAllList, getCityAllFilterList } = action;
      return {
        ...state,
        getCityAllList,
        getCityAllFilterList
      };
    case GET_CAMPAIGN_SUB_CATEGORY:
      const { getCampaignSubCategoryReport } = action;
      return {
        ...state,
        getCampaignSubCategoryReport,
      };
    case GET_ADVERTISER_CREATIVE_GROUP:
      const { getAdvertiserCreativeGroup } = action;
      return {
        ...state,
        getAdvertiserCreativeGroup,
      };
    case GET_IO_ADVERTISER_LIST_REPORT:
      const { ioAdvertisersReport } = action;
      return {
        ...state,
        ioAdvertisersReport,
      };
    case GET_EXCHANGE_LIST_REPORT:
      const { exchangeReport } = action;
      return {
        ...state,
        exchangeReport,
      };
    case GET_TENANT_LIST_ALL:
      const { tenantListAll } = action;
      return {
        ...state,
        tenantListAll,
      };
    case GET_SUPPLY_PARTNER_LIST_ALL:
      const { supplyPartnerListAll } = action;
      return {
        ...state,
        supplyPartnerListAll,
      };
    case GET_DEMAND_PARTNER_SEAT_LIST_ALL:
      const { demandpartnerSeatList } = action;
      return {
        ...state,
        demandpartnerSeatList,
      };
    case GET_DEMAND_PARTNER_LIST_ALL:
      const { demandpartnerList } = action;
      return {
        ...state,
        demandpartnerList,
      };
    case GET_TENANT_DEMAND_PARTNER_LIST:
      const { tenantDemandpartnerList } = action;
      return {
        ...state,
        tenantDemandpartnerList,
      };
    case GET_ADMIN_SUPPLY_PARTNER_LIST_ALL:
      const { adminSupplypartnerData } = action;
      return {
        ...state,
        adminSupplypartnerData,
      };
    case GET_TENANT_SUPPLY_PARTNER_LIST_ALL:
      const { adminTenantSupplypartnerData } = action;
      return {
        ...state,
        adminTenantSupplypartnerData,
      };
    case GET_ADMIN_ION_SUPPLY_PARTNER_LIST_ALL:
      const { ionSupplypathData } = action;
      return {
        ...state,
        ionSupplypathData,
      };
    case GET_ADMIN_PVT_SUPPLY_PARTNER_LIST_ALL:
      const { pvtSupplypathData } = action;
      return {
        ...state,
        pvtSupplypathData,
      };
    case GET_CAMPAIGN_CATEGORY_TYPE_LIST:
      const { campaignCategoryTypeList } = action;
      return {
        ...state,
        campaignCategoryTypeList,
      };
    case GET_LIST_FEATURE_ALL:
      const { listFeatureAll, responseType } = action;
      return {
        ...state,
        [responseType]: listFeatureAll,
      };
    case GET_FEATURE_LIST_ALL:
      const { featurelist } = action;
      return {
        ...state,
        featurelist,
      };
    case GET_MEDIATION_LIST:
      const { mediationList } = action;
      return {
        ...state,
        mediationList,
      };
    case GET_MEDIATION_AD_GROUP_LIST:
      const { mediationAdGroupList } = action;
      return {
        ...state,
        mediationAdGroupList,
      };
    case GET_PRIVATE_MARKET_PLACE_LIST:
      const { privateMarketPlaceList } = action;
      return {
        ...state,
        privateMarketPlaceList,
      };
    case GET_AGREEMENT_LIST_ALL:
      const { adminAgreementData } = action;
      return {
        ...state,
        adminAgreementData,
      };
    case GET_AGREEMENT_CONNECTION_LIST:
      const { connectionAgreementData } = action;
      return {
        ...state,
        connectionAgreementData,
      };
    case GET_ADMIN_USER_LIST_ALL:
      const { adminUserData } = action;
      return {
        ...state,
        adminUserData,
      };
    case GET_PLATFORM_LIST_ALL:
      const { platformListAll } = action;
      return {
        ...state,
        platformListAll,
      };
    case GET_ADMIN_ROLES_LIST_ALL:
      const { adminRolesData } = action;
      return {
        ...state,
        adminRolesData,
      };
    case GET_DEMAND_PARTNER_NAME_LIST_ALL:
      const { demandPartnerNameList } = action;
      return {
        ...state,
        demandPartnerNameList,
      };
    case GET_USER_PERMISSION:
      const { getUserPermissionList, defaultRoute } = action;
      return {
        ...state,
        getUserPermissionList,
        defaultRoute
      };
    case GET_ADVERTISER_LIST:
      const { advertiserList } = action;
      return {
        ...state,
        advertiserList
      }
    case GET_APR_LIST_ALL:
      const { aprListAll } = action;
      return {
        ...state,
        aprListAll,
      };
    case GET_SEGMENT_LIST_ALL:
      const { getSegmentList } = action;
      return {
        ...state,
        getSegmentList,
      };
    case GET_HIERARCHY_LIST_ALL:
      const { getHierarchyList } = action;
      return {
        ...state,
        getHierarchyList,
      };
    case GET_DATA_CAPTURE_LIST_ALL:
      const { getDataCaptureList } = action;
      return {
        ...state,
        getDataCaptureList,
      };
    case GET_AUDIENCE_HIERARCHY_LIST_ALL:
      const { audienceHierarchyList } = action;
      return {
        ...state,
        audienceHierarchyList,
      };
    case GET_PINCODE_LIST:
      const { getPincodeList } = action;
      return {
        ...state,
        getPincodeList,
      };
    case GET_CAMPAIGN_SITE_LIST_ALL:
      const { getCampaignSiteAll } = action;
      return {
        ...state,
        getCampaignSiteAll,
      };
    case GET_CAMPAIGN_PERFORMANCE_REPORT_TREND:
      const { campaignPerformanceReportTrend } = action;
      return {
        ...state,
        campaignPerformanceReportTrend,
      };
    case GET_MEDIA_PLANNING_REPORT_TREND:
      const { mediaPlanningReportTrend } = action;
      return {
        ...state,
        mediaPlanningReportTrend,
      };
    case GET_PINCODE_LIST_ALL:
      const { getPincodeAllList, getPincodeAllFilterList } = action;
      return {
        ...state,
        getPincodeAllList,
        getPincodeAllFilterList
      };
    case GET_CAMPAIGN_PIXEL_LIST:
      const { campaignPixelList } = action;
      return {
        ...state,
        campaignPixelList
      };
    case GET_SAVE_REPORT:
      const { saveReport } = action;
      return {
        ...state,
        saveReport
      };
    case GET_GENERATE_REPORT:
      const { generateReport } = action;
      return {
        ...state,
        generateReport
      };
    case GET_REFRESH_REPORT:
      const { refreshReport } = action;
      return {
        ...state,
        refreshReport
      };
    case GET_MEDIA_SAVE_REPORT:
      const { savedReport } = action;
      return {
        ...state,
        savedReport
      };

    case GET_ACCOUNTS_LIST:
      const { accountsList } = action;
      return {
        ...state,
        accountsList
      }


    case GET_ROADBLOCK_LIST:
      const { roadblockList } = action;
      return {
        ...state,
        roadblockList
      };
    case POST_CAMPAIGN_PERFORMACE_REPORT:
      const { campaignPerformanceList } = action;
      return {
        ...state,
        campaignPerformanceList
      }
    case POST_GEO_REPORT:
      const { geoReportList } = action;
      return {
        ...state,
        geoReportList
      }
    case POST_CREATIVE_PERFORMANCE_REPORT:
      const { creativeAllReportList } = action;
      return {
        ...state,
        creativeAllReportList
      }
    case POST_AGE_GENDER_REPORT:
      const { ageGenderAllReportList } = action;
      return {
        ...state,
        ageGenderAllReportList
      }
    case RECO_IMPLEMENTATION:
      const { recoImplementation } = action;
      return {
        ...state,
        recoImplementation
      }
    case CREATE_ADVERTISER:
      return {
        ...state,
        advertiserCreateList: action.payload
      }
    case ADVERTISER_LIST:
      return {
        ...state,
        listAdvertiser: action.listAdvertiser ? action.listAdvertiser : {}
      }

    case GET_MEDIA_PLAN_LIST:
      return {
        ...state,
        mediaPlanList: action.payload
      }
    case GET_OPTIMIZER_LIST:
      return {
        ...state,
        optimizerList: action.payload
      }

    case POST_MEDIA_PLAN_CREATION:
      return {
        ...state,
        mediaplancreationData: action.payload
      }



    case GET_AGE_LIST:
      return {
        ...state,
        ageList: action.payload
      }
    case GET_CATEGORY_LIST:
      return {
        ...state,
        categoryList: action.payload
      }
    case GET_SUBCATEGORY_LIST:
      return {
        ...state,
        subCategoryList: action.payload
      }


    case THIRD_PARTY_MAPPED_ACCOUNT:
      const { thirdPartyAccount } = action;
      return {
        ...state,
        thirdPartyAccount
      };

    case USER_MAPPED_SEATS:
      const { userMappedSeats } = action;
      return {
        ...state,
        userMappedSeats
      };

    case THIRD_PARTY_LOGIN_PARTNERS_DATA:
      const { thirdPartyLoginPartnersData } = action;

      return {
        ...state,
        thirdPartyLoginPartnersData
      };

    case THIRD_PARTY_LOGIN_VERIFICATION_DATA:
      const { thirdPartyLoginData } = action;

      return {
        ...state,
        thirdPartyLoginData
      };

    case GET_PRIMARY_GOAL:
      return {
        ...state,
        primaryGoalList: action.payload
      }
    case GET_SECONDARY_GOAL:
      return {
        ...state,
        secondaryGoalList: action.payload
      }
    case GET_UNMAPPED_CAMPAIGN_LIST:
      return {
        ...state,
        unmappedCampaignList: action.payload
      }
    case POST_CAMPAIGN_PERFORMACE_TOTAL_REPORT:
      return {
        ...state,
        campaignPerformanceTotal: action.campaignPerformanceTotal ? action.campaignPerformanceTotal : {}
      }
    case POST_CAMPAIGN_PERFORMACE_DATEWISE_REPORT:
      return {
        ...state,
        campaignPerformanceDateWise: action.campaignPerformanceDateWise ? action.campaignPerformanceDateWise : {}
      }
    case POST_CHANNEL_SPEND:
      return {
        ...state,
        channelSpend: action.channelSpend ? action.channelSpend : {}
      }

    case PAYMENT_ACCESS_ACTION_TYPE:
      return {
        ...state,
        paymentAccess: action.paymentAccess ? action.paymentAccess : {}
      }
    case POST_WORLD_MAP_DATA:
      return {
        ...state,
        worldMapData: action.worldMapData ? action.worldMapData : {}
      }
    case GET_CURRENCY_LIST:
      return {
        ...state,
        currencyList: action.currencyList ? action.currencyList : {}
      }
    case GET_ALL_CURRENCY:
      const { allCurrencyData } = action;
      return {
        ...state,
        allCurrencyData
      }
    case GET_DATACONFIG_LIST_DATA:
      return {
        ...state,
        dataConfigListData: action.dataConfigListData ? action.dataConfigListData : {}
      }
    case GET_DATA_CONFIG:
      return {
        ...state,
        dataConfigAll: action.dataConfigAll ? action.dataConfigAll : {}
      }
    case GET_CAMPAIGN_NAME:
      const { campaignNameData } = action;
      return {
        ...state,
        campaignNameData,
      };
    case GET_PREVIEW_DATA:
      const { previewData } = action;
      return {
        ...state,
        previewData,
      };

    case SET_SELECTED_TENANT_FOR_PAYMENT:
      const { selectedTenantValue } = action;
      return {
        ...state,
        selectedTenantValue
      }
    case BASIC_DETAILS:
      const { basicDetailsForm } = action;
      return {
        ...state,
        basicDetailsForm
      };
    case CUSTOM_PLAN:
      const { customPlanData } = action;
      return {
        ...state,
        customPlanData
      };
    case SET_STEPPER:
      const { stepperData } = action;
      return {
        ...state,
        stepperData
      };
    case STRATEGY_LIST:
      const { strategyData } = action;


      return {
        ...state,
        strategyData
      };
    case SET_LOCATION_STRATEGY:
      const { locationMap } = action;


      return {
        ...state,
        locationMap
      };
    case RECOMMENDED_PLAN:
      const { recommendedPlanData } = action;

      return {
        ...state,
        recommendedPlanData
      };
    case PREFERENCE_LIST:
      const { preferenceData } = action;


      return {
        ...state,
        preferenceData
      };
    case GET_RECO_LIST:
      const { recommendedList } = action;


      return {
        ...state,
        recommendedList
      };

    case SUBSCRIPTION_CURRENT_LIST_ALL:
      const { subscriptionCurrentData } = action;

      return {
        ...state,
        subscriptionCurrentData
      };

    case GET_NEW_OPTIMIZER_LIST:
      const { optimizerListNew } = action;

      return {
        ...state,
        optimizerListNew
      }

    case GET_USER_PROFILE_DETAILS:
      const { userProfileDetails } = action;

      return {
        ...state,
        userProfileDetails
      }

    case GET_FEATURE_MODULE:
      const { featureModuleData } = action;

      return {
        ...state,
        featureModuleData
      }
    //cdr

    case POST_AGE_REPORT_CDR:
      const { ageAllReportListDataCdr } = action
      return {
        ...state,
        ageAllReportListDataCdr,
      }
    case POST_GENDER_REPORT_CDR:
      const { genderAllReportListDataCdr } = action
      return {
        ...state,
        genderAllReportListDataCdr
      }
    case POST_PERFORMANCE_REPORT_CDR:
      const { graphDataCdr, graphId } = action
      const mergedGraphDataCdr = {
        ...state.graphDataCdr,
        [graphId]: graphDataCdr
      };

      let filteredGraphData = Object.keys(mergedGraphDataCdr).reduce((acc, key) => {
        if (key !== 'undefined') {
          acc[key] = mergedGraphDataCdr[key];
        }
        return acc;
      }, {});
      if (graphDataCdr === null) {
        filteredGraphData = graphDataCdr;
      }
      return {
        ...state,
        graphDataCdr: filteredGraphData,
      }
    case POST_CREATIVE_DETAILS_CDR:
      const { creativeDetailsListCdr } = action;
      return {
        ...state,
        creativeDetailsListCdr,
      };
    case GET_ADVERTISER_LIST_CDR:
      const { advertiserListCdr } = action;
      return {
        ...state,
        advertiserListCdr
      }
    case GET_SAVE_REPORT_CDR:
      const { saveReportCdr } = action;
      return {
        ...state,
        saveReportCdr
      };
    case POST_CAMPAIGN_PERFORMACE_REPORT_CDR:
      const { campaignPerformanceListCdr } = action;
      return {
        ...state,
        campaignPerformanceListCdr
      }
    case POST_PERFORMANCE_SUMMARY_REPORT_DATA:
      const { summarisedPerformanceReportData } = action;
      return {
        ...state,
        summarisedPerformanceReportData
      }
    case POST_PERFORMANCE_DATEWISE_REPORT_DATA:
      const { datewisePerformanceReportData } = action;
      return {
        ...state,
        datewisePerformanceReportData
      }
    case POST_PERFORMANCE_WEEKWISE_REPORT_DATA:
      const { weekwisePerformanceReportData } = action;
      return {
        ...state,
        weekwisePerformanceReportData
      }
    case POST_CREATIVE_DETAIL_REPORT_DATA:
      const { creativeDetailReportData } = action;
      return {
        ...state,
        creativeDetailReportData
      }
    case POST_CREATIVE_DETAIL_REPORT_SUMMARISED_DATA:
      const { creativeDetailReportSummaryData } = action;
      return {
        ...state,
        creativeDetailReportSummaryData
      }
    case POST_CREATIVE_DETAIL_REPORT_DATEWISE_DATA:
      const { creativeDetailReportDatewiseData } = action;
      return {
        ...state,
        creativeDetailReportDatewiseData
      }
    case POST_CREATIVE_DETAIL_REPORT_WEEKWISE_DATA:
      const { creativeDetailReportWeekwiseData } = action;
      return {
        ...state,
        creativeDetailReportWeekwiseData
      }

    case POST_GEO_REPORT_DATA:
      const { geoReportData } = action;
      return {
        ...state,
        geoReportData
      }
    case POST_DEMOGRAPHIC_AGE_REPORT_DATA:
      const { demographicAgeReportData } = action;
      return {
        ...state,
        demographicAgeReportData
      }
    case POST_DEMOGRAPHIC_AGE_REPORT_SUMMARY_DATA:
      const { demographicAgeReportSummaryData } = action;
      return {
        ...state,
        demographicAgeReportSummaryData
      }
    case POST_DEMOGRAPHIC_AGE_REPORT_DATEWISE_DATA:
      const { demographicAgeReportDatewiseData } = action;
      return {
        ...state,
        demographicAgeReportDatewiseData
      }
    case POST_DEMOGRAPHIC_AGE_REPORT_WEEKWISE_DATA:
      const { demographicAgeReportWeekwiseData } = action;
      return {
        ...state,
        demographicAgeReportWeekwiseData
      }
    case POST_DEMOGRAPHIC_GENDER_REPORT_DATA:
      const { demographicGenderReportData } = action;
      return {
        ...state,
        demographicGenderReportData
      }
    case POST_DEMOGRAPHIC_GENDER_REPORT_SUMMARY_DATA:
      const { demographicGenderReportSummaryData } = action;
      return {
        ...state,
        demographicGenderReportSummaryData
      }
    case POST_DEMOGRAPHIC_GENDER_REPORT_DATEWISE_DATA:
      const { demographicGenderReportDatewiseData } = action;
      return {
        ...state,
        demographicGenderReportDatewiseData
      }
    case POST_DEMOGRAPHIC_GENDER_REPORT_WEEKWISE_DATA:
      const { demographicGenderReportWeekwiseData } = action;
      return {
        ...state,
        demographicGenderReportWeekwiseData
      }
    case POST_DOMAIN_REPORT_DATA:
      const { domainReportData } = action;
      return {
        ...state,
        domainReportData
      }
    case POST_DOMAIN_REPORT_SUMMARY_DATA:
      const { domainReportSummaryData } = action;
      return {
        ...state,
        domainReportSummaryData
      }
    case POST_DOMAIN_REPORT_DATEWISE_DATA:
      const { domainReportDatewiseData } = action;
      return {
        ...state,
        domainReportDatewiseData
      }
    case POST_DOMAIN_REPORT_WEEKWISE_DATA:
      const { domainReportWeekwiseData } = action;
      return {
        ...state,
        domainReportWeekwiseData
      }
    case POST_DEVICE_DETAIL_REPORT_DATA:
      const { deviceDetailReportData } = action;
      return {
        ...state,
        deviceDetailReportData
      }
    case POST_DEVICE_DETAIL_REPORT_SUMMARY_DATA:
      const { deviceDetailReportSummaryData } = action;
      return {
        ...state,
        deviceDetailReportSummaryData
      }
    case POST_DEVICE_DETAIL_REPORT_DATEWISE_DATA:
      const { deviceDetailReportDatewiseData } = action;
      return {
        ...state,
        deviceDetailReportDatewiseData
      }
    case POST_DEVICE_DETAIL_REPORT_WEEKWISE_DATA:
      const { deviceDetailReportWeekwiseData } = action;
      return {
        ...state,
        deviceDetailReportWeekwiseData
      }
    case POST_KEYWORDS_SUMMARY_REPORT_DATA:
      const { keywordsReportSummaryData } = action;
      return {
        ...state,
        keywordsReportSummaryData
      }
    case POST_KEYWORDS_DATEWISE_REPORT_DATA:
      const { keywordsReportDatewiseData } = action;
      return {
        ...state,
        keywordsReportDatewiseData
      }
    case POST_KEYWORDS_WEEKWISE_REPORT_DATA:
      const { keywordsReportWeekwiseData } = action;
      return {
        ...state,
        keywordsReportWeekwiseData
      }
    case POST_AUDIENCE_SUMMARY_REPORT_DATA:
      const { audienceReportSummaryData } = action;
      return {
        ...state,
        audienceReportSummaryData
      }
    case POST_AUDIENCE_DATEWISE_REPORT_DATA:
      const { audienceReportDatewiseData } = action;
      return {
        ...state,
        audienceReportDatewiseData
      }
    case POST_AUDIENCE_WEEKWISE_REPORT_DATA:
      const { audienceReportWeekwiseData } = action;
      return {
        ...state,
        audienceReportWeekwiseData
      }
    case POST_OS_REPORT_SUMMARY_DATA:
      const { osDetailReportSummaryData } = action;
      return {
        ...state,
        osDetailReportSummaryData
      }
    case POST_OS_REPORT_DATEWISE_DATA:
      const { osDetailReportDatewiseData } = action;
      return {
        ...state,
        osDetailReportDatewiseData
      }
    case POST_OS_REPORT_WEEKWISE_DATA:
      const { osDetailReportWeekwiseData } = action;
      return {
        ...state,
        osDetailReportWeekwiseData
      }
    case POST_GEO_REPORT_CDR:
      const { geoReportListCdr } = action;
      return {
        ...state,
        geoReportListCdr
      }
    case POST_CAMPAIGN_PERFORMACE_TOTAL_REPORT_CDR:
      return {
        ...state,
        campaignPerformanceTotalReportCdr: action.campaignPerformanceTotal ? action.campaignPerformanceTotal : {}
      }
    case POST_CAMPAIGN_PERFORMACE_DATEWISE_REPORT_CDR:

      return {
        ...state,
        campaignPerformanceDateWiseCdr: action.campaignPerformanceDateWiseCdr ? action.campaignPerformanceDateWiseCdr : {}
      }
    case POST_CHANNEL_SPEND_CDR:

      return {
        ...state,
        channelSpendCdr: action.channelSpend ? action.channelSpend : {}
      }
    case POST_WORLD_MAP_DATA_CDR:

      return {
        ...state,
        worldMapDataCdr: action.worldMapData ? action.worldMapData : {}
      }
    // RO functionality disabled
    // case MANDATE_GROUP_LIST:
    //   const { mandatesGroupList } = action;
    //   return {
    //     ...state,
    //     mandatesGroupList
    //   }
    case SET_AUDIENCE_MARKETPLACE_LOADING:
      return updateAudienceMarketplaceEntityState(state, action.entityType, {
        loading: Boolean(action.loading)
      });
    case SET_AUDIENCE_MARKETPLACE_ERROR:
      return updateAudienceMarketplaceEntityState(state, action.entityType, {
        error: action.error || "",
        loading: false
      });
    case GET_AUDIENCE_MARKETPLACE_LIST:
      return updateAudienceMarketplaceEntityState(state, action.entityType, {
        listResponse: action.listResponse || null,
        filters: action.filters || getCurrentAudienceMarketplaceEntityState(state, action.entityType).filters,
        searchText: action.searchText !== undefined ? action.searchText : getCurrentAudienceMarketplaceEntityState(state, action.entityType).searchText,
        error: "",
        loading: false
      });
    case GET_AUDIENCE_MARKETPLACE_FILTER_OPTIONS:
      return updateAudienceMarketplaceEntityState(state, action.entityType, {
        filterOptionsResponse: action.filterOptionsResponse || null,
        error: "",
        loading: false
      });
    case SET_AUDIENCE_MARKETPLACE_FILTERS:
      return updateAudienceMarketplaceEntityState(state, action.entityType, {
        filters: action.filters || getAudienceMarketplaceDefaultFilters()
      });
    case RESET_AUDIENCE_MARKETPLACE_FILTERS:
      return updateAudienceMarketplaceEntityState(state, action.entityType, {
        filters: action.filters || getAudienceMarketplaceDefaultFilters()
      });
    case SET_AUDIENCE_MARKETPLACE_SEARCH:
      return updateAudienceMarketplaceEntityState(state, action.entityType, {
        searchText: action.searchText || ""
      });
    case SET_AUDIENCE_MARKETPLACE_SELECTED_RECORD:
      return updateAudienceMarketplaceEntityState(state, action.entityType, {
        selectedRecord: action.selectedRecord || null
      });
    case GET_AUDIENCE_MARKETPLACE_DETAIL:
      return updateAudienceMarketplaceEntityState(state, action.entityType, {
        detailResponse: action.detailResponse || null,
        error: "",
        loading: false
      });
    case POST_AUDIENCE_MARKETPLACE_ACTION:
      return updateAudienceMarketplaceEntityState(state, action.entityType, {
        postResponse: action.postResponse || null,
        error: ""
      });
    default:
      return state;
  }
};

export default app;
